import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class Rendering extends BaseOption {
  static userInterfaceComponent = {
    label: "Rendering Algorithm",
    component: inspectorTools.SIMPLE_PICKER,
    props: {
      options: [
        {
          name: "Auto",
          id: "auto",
        },
        {
          name: "Smooth",
          id: "smooth",
        },
        {
          name: "High-Quality",
          id: "high-quality",
        },
        {
          name: "Pixelated",
          id: "pixelated",
        },
        {
          name: "Crisp-Edges",
          id: "crisp-edges",
        },
        {
          name: "Initial",
          id: "initial",
        },
        {
          name: "Inherit",
          id: "inherit",
        },
        {
          name: "Unset",
          id: "unset",
        },
        {
          name: "Revert",
          id: "revert",
        },
        {
          name: "Revert-Layer",
          id: "revert-layer",
        },
      ],
    },
  };

  static defaultValue = "auto";
}
